export interface Coordinates {
  latitude?: number | null;
  longitude?: number | null;
}

const earthRadiusKm = 6_371;

export function hasValidCoordinates(
  value: Coordinates
): value is Coordinates & { latitude: number; longitude: number } {
  return (
    typeof value.latitude === 'number' &&
    Number.isFinite(value.latitude) &&
    value.latitude >= -90 &&
    value.latitude <= 90 &&
    typeof value.longitude === 'number' &&
    Number.isFinite(value.longitude) &&
    value.longitude >= -180 &&
    value.longitude <= 180
  );
}

export function haversineDistanceKm(from: Coordinates, to: Coordinates): number | undefined {
  if (!hasValidCoordinates(from) || !hasValidCoordinates(to)) return undefined;

  const toRadians = (degrees: number) => (degrees * Math.PI) / 180;
  const latitudeDelta = toRadians(to.latitude - from.latitude);
  const longitudeDelta = toRadians(to.longitude - from.longitude);
  const a =
    Math.sin(latitudeDelta / 2) ** 2 +
    Math.cos(toRadians(from.latitude)) *
      Math.cos(toRadians(to.latitude)) *
      Math.sin(longitudeDelta / 2) ** 2;
  return earthRadiusKm * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

export function formatApproximateDistance(distanceKm: number | undefined): string | undefined {
  if (distanceKm === undefined || !Number.isFinite(distanceKm) || distanceKm < 0) return undefined;
  if (distanceKm < 1) return `Khoảng ${Math.round(distanceKm * 1_000)} m`;
  return `Khoảng ${distanceKm.toFixed(1)} km`;
}
